module.exports = __webpack_public_path__ + "img/underline.42cad9bd.svg";